import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import { Menu, Transition } from "@headlessui/react";
import { usePopper } from "react-popper";
import { useRef, useState } from "react";
import { bottom, top, left, right } from "@popperjs/core";
import UserImage from "../../assets/images/member-01.webp";
import Image from "../../components/elements/Image";
import { classNames } from "../../helpers/classNames";
import LogoutModal from "../../components/common/LogoutModal";
import MyProfile from "../../pages/front/profile/MyProfile";
import FrontPasswordChange from "../../pages/front/profile/FrontPasswordChange";
import { Tooltip } from "react-tooltip";

const UserDropdown = ({
  role,
  data,
  isFront,
  xPlacement,
  dropdownContainer,
  ...props
}) => {
  const popperElRef = useRef(null);
  const [targetElement, setTargetElement] = useState(null);
  const [popperElement, setPopperElement] = useState(null);
  const [isOpen, setOpen] = useState(false);
  const [passwordModal, setPasswordModal] = useState({
    isOpen: false,
  });
  const [profileModal, setProfileModal] = useState({
    isOpen: false,
  });
  const placements = {
    bottom: bottom,
    bottomLeft: "bottom-start",
    bottomRight: "bottom-end",
    top: top,
    topLeft: "top-start",
    topRight: "top-end",
    right: right,
    left: left,
    "": bottom,
  };
  const { styles, attributes } = usePopper(targetElement, popperElement, {
    placement: placements[xPlacement],
    modifiers: [
      {
        name: "offset",
        options: {
          offset: [0, 8],
        },
      },
    ],
  });

  const dropdownData =
    isFront === true
      ? [
        {
          _id: 1,
          name: "Profile",
          icon: "fa-regular fa-circle-user",
          onclick: (val) => {
            setProfileModal({ isOpen: true });
          },
          standout: false,
        },
        {
          _id: 2,
          name: "Change Password",
          icon: "fa-regular fa-gear",
          onclick: (val) => {
            setPasswordModal({ isOpen: true });
          },
          standout: false,
        },
        {
          _id: 3,
          name: "Logout",
          icon: "fa-regular fa-arrow-right-from-arc",
          onclick: (val) => {
            setOpen(true);
          },
          standout: true,
        },
      ]
      : [
        {
          _id: 1,
          name: "Profile",
          icon: "fa-regular fa-circle-user",
          link: "/admin/profile",
          standout: false,
        },
        {
          _id: 2,
          name: "Settings",
          icon: "fa-regular fa-gear",
          link: "/admin/site-settings",
          standout: false,
        },
        {
          _id: 3,
          name: "Logout",
          icon: "fa-regular fa-arrow-right-from-arc",
          onclick: (val) => {
            setOpen(true);
          },
          standout: true,
        },
      ];

  return (
    <>
      <Menu as="div">
        {({ open }) => (
          <>
            <Menu.Button ref={setTargetElement} className="flex items-center">
              <div
                className="relative w-full h-10 flex items-center justify-center focus:ring-0 transition-all duration-200"
                data-tooltip-id="profile"
              >
                <div className="flex-shrink-0 rounded-full overflow-hidden">
                  {!data?.image ? (
                    <div className="flex items-center justify-center bg-orange-300 rounded-full w-7 md:w-8 h-7 md:h-8">
                      <i className="fa-regular fa-user" />
                    </div>
                  ) : (
                    <div className="w-8 aspect-square rounded-full overflow-hidden bg-slate-300 dark:bg-slate-600">
                      <Image
                        src={data?.image ? data?.image : UserImage}
                        effect={"blur"}
                        alt={"Administrator"}
                        className={"object-cover"}
                      />
                    </div>
                    
                  )}
                </div>
                <div
                  className={`text-xs md:text-sm font-medium mx-2 hidden md:block ${role === "admin" ? "text-black dark:text-slate-400" : "text-white dark:text-slate-400"
                    }`}
                >
                  {data?.name && data?.name}
                  <Tooltip
                    id="profile"
                    place="left"
                    className="!text-slate-500 dark:!text-slate-200 !text-xs !bg-slate-950 dark:!bg-slate-400 !bg-opacity-100 z-100 hidden md:block"
                    
                    render={() => (
                      <div className="text-white dark:text-slate-200">
                        <div className="capitalize text-center">{data?.name}</div>
                        <div>Email : {data?.email}</div>
                      </div>
                    )}
                  />
                </div>
                <div className="text-sm text-slate-300 dark:text-slate-400 hidden md:block">
                  <i
                    className={classNames(
                      "fa-regular fa-fw fa-chevron-down transition-all duration-200",
                      role === "admin" ? "text-black dark:text-slate-400" : "text-white dark:text-slate-400",
                      open ? "-rotate-180" : ""
                    )}
                  ></i>
                </div>
              </div>
            </Menu.Button>
            <Transition
              as={Fragment}
              className="z-50"
              enter="transition ease-out duration-100"
              enterFrom="transform opacity-0 scale-95"
              enterTo="transform opacity-100 scale-100"
              leave="transition ease-in duration-75"
              leaveFrom="transform opacity-100 scale-100"
              leaveTo="transform opacity-0 scale-95"
              beforeEnter={() => setPopperElement(popperElRef.current)}
              afterLeave={() => setPopperElement(null)}
              ref={popperElRef}
              style={styles.popper}
              {...attributes.popper}
            >
              <Menu.Items
                className={classNames(
                  "absolute border border-slate-200 dark:border-slate-600 dark:divide-slate-700 w-40 origin-top-right rounded-md bg-white dark:bg-slate-800 shadow-lg focus:outline-none py-1",
                  dropdownContainer
                )}
              >
                <div className="py-1 max-h-80 overflow-auto scroll-smooth scrollbar">
                  {dropdownData.map((item) => (
                    <Menu.Item key={item._id}>
                      {({ active }) =>
                        item?.link ? (
                          <Link
                            to={item?.link}
                            className={classNames(
                              "group flex w-full items-center px-3 py-1.5 text-sm gap-2 transition-all duration-200",
                              active
                                ? "bg-orange-100 text-orange-500 dark:bg-orange-500/20"
                                : "text-slate-500 dark:text-slate-400",
                              item.standout
                                ? "!text-opplio-red hover:!bg-opplio-red/10"
                                : "",
                              item.class
                            )}
                          >
                            {item.icon && (
                              <i className={classNames("fa-fw", item.icon)}></i>
                            )}
                            <span>{item.name}</span>
                          </Link>
                        ) : (
                          <div
                            onClick={item?.onclick}
                            className={classNames(
                              "group cursor-pointer flex w-full items-center px-3 py-1.5 text-sm gap-2 transition-all duration-200",
                              active
                                ? "bg-orange-100 text-orange-500 dark:bg-orange-500/20"
                                : "text-slate-500 dark:text-slate-400",
                              item.standout
                                ? "!text-red-500 hover:!bg-red-500/10 hover:dark:!bg-red-500/20"
                                : "",
                              item.class
                            )}
                          >
                            {item.icon && (
                              <i className={classNames("fa-fw", item.icon)}></i>
                            )}
                            <span>{item.name}</span>
                          </div>
                        )
                      }
                    </Menu.Item>
                  ))}
                </div>
              </Menu.Items>
            </Transition>
          </>
        )}
      </Menu>
      <LogoutModal isOpen={isOpen} setOpen={setOpen} />
      <MyProfile
        profileModal={profileModal}
        setProfileModal={setProfileModal}
      />
      <FrontPasswordChange
        passwordModal={passwordModal}
        setPasswordModal={setPasswordModal}
      />
    </>
  );
};

export default UserDropdown;
